import { getUserInfo, getStatus } from "@/api/user";
import { queryDetailAndContent } from "@/api/other";

export default {
  namespaced: true,
  state: {
    userinfo: null,
    meetInfo: null,
  },
  getters: {
    getUserInfo: (state) => state.userinfo,
    getMeetInfo: (state) => state.meetInfo,
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userinfo = payload;
    },
    setMeetInfo(state, payload) {
      state.meetInfo = payload;
    },
  },
  actions: {
    async getUserInfoAction({ commit }) {
      try {
        await getStatus();
        const { results } = await getUserInfo();
        // 0-项目认证，1-源默认证，2-会员，3-游客 (0,1)已认证 统一认证状态，方便修改
        let userStatusFlag = results.status == 0 || results.status == 1;
        results.userStatusFlag = userStatusFlag;
        commit("setUserInfo", results);
        return Promise.resolve(results);
      } catch (error) {
        console.error(error);
        return Promise.reject();
      }
    },
    async getMeetInfoAction({ commit }, datas) {
      try {
        const { results } = await queryDetailAndContent({ id: datas.id });
        commit("setMeetInfo", results);
        return Promise.resolve(results);
      } catch (error) {
        console.error(error);
        return Promise.reject();
      }
    },
  },
};
